import { render, staticRenderFns } from "./import-data-history.vue?vue&type=template&id=543a684a&scoped=true&"
import script from "./import-data-history.vue?vue&type=script&lang=js&"
export * from "./import-data-history.vue?vue&type=script&lang=js&"
import style0 from "./import-data-history.vue?vue&type=style&index=0&id=543a684a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543a684a",
  null
  
)

export default component.exports